import Swiper, { Pagination, Navigation } from "swiper";
// import styles bundle
import '../../../node_modules/swiper/swiper.min.css';

export default class ProductsCarousel {
    constructor(element) {
        this.passedElement = element;
        this.searchQuery = "";
        this.init();
    }

    init = () => {
        if (!this.initialised) {
            this.initialised = true;
            this.getElements();
            this.addEventListeners();
        }
    }

    setSwiper = (swiperContainer) => {
        Swiper.use([Pagination, Navigation]);
        const testimonialsSwiper = new Swiper(swiperContainer, {
            direction: 'horizontal',
            watchOverflow: true,
            loop: false,
            autoHeight: false,
            centeredSlides: false,
            slidesPerView: 1,
            breakpoints: {
                1200: { slidesPerView: 3 }
            },
            spaceBetween: 0,
            pagination: {
                el: ".swiper-pagination",
                dynamicBullets: true,
                dynamicMainBullets: 3,
                clickable: true,
            },
            autoplay: false,
        });
    }

    getElements = () => {
        this.setSwiper(this.passedElement);
    }

    addEventListeners = () => {
        //Add all event listeners bellow
    }

}